// Generated by scripts/build-ui-icons.mjs.
export { Clock as default } from "../ui/glyphs-2";
